import flatten from 'lodash/flatten';

export const MEDIA_TYPE = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  UNKNOWN: 'unknown',
};

export const IMAGE_SIZE = {
  '2000': { width: 2000 },
  '2000x1333': { width: 2000, height: 1333 },
  '2000x900': { width: 2000, height: 900 },
  '2000x714': { width: 2000, height: 714 },
  '2000x615': { width: 2000, height: 615 },
  '1600x1000': { width: 1600, height: 1000 },
  '2000x240': { width: 2000, height: 240 },
  '1440x867': { width: 1440, height: 967 },
  '1440x576': { width: 1440, height: 576 },
  '1440x300': { width: 1440, height: 300 },
  '1000x600': { width: 1000, height: 600 },
  '800x450': { width: 800, height: 450 },
  '700x567': { width: 700, height: 567 },
  '700x460': { width: 700, height: 460 },
  '700x300': { width: 700, height: 300 },
  '700x220': { width: 700, height: 220 },
  '600x850': { width: 600, height: 850 },
  '680x453': { width: 680, height: 453 },
  '600x400': { width: 600, height: 400 },
  '600x120': { width: 600, height: 120 },
  '544x360': { width: 544, height: 360 },
  '450x300': { width: 450, height: 300 },
  '450x150': { width: 450, height: 150 },
  '420x150': { width: 420, height: 150 },
  '390x576': { width: 390, height: 576 },
  '390x428': { width: 390, height: 428 },
  '350x326': { width: 350, height: 326 },
  '300x191': { width: 300, height: 191 },
  '300x75': { width: 300, height: 75 },
  '100x25': { width: 100, height: 25 },
};

export const CROPPING_EXTENSIONS = ['.jpg', '.jpeg', '.png'];

export const FILTER_OPTION = {
  ALL: {
    key: '',
    label: 'Show all',
  },
  IMAGES: {
    key: MEDIA_TYPE.IMAGE,
    label: 'Show images',
  },
  DOCUMENTS: {
    key: MEDIA_TYPE.DOCUMENT,
    label: 'Show documents',
  },
};
export const FILTER_OPTIONS = Object.values(FILTER_OPTION);

export const EXTENSIONS = {
  [MEDIA_TYPE.IMAGE]: [...CROPPING_EXTENSIONS, '.gif'],
  [MEDIA_TYPE.DOCUMENT]: ['.pdf', '.ppt', '.pptx', '.docx', '.xlsx'],
  [MEDIA_TYPE.UNKNOWN]: [],
};

export const ALL_FILE_TYPES = flatten(Object.values(EXTENSIONS));

export const PATHS = {
  [MEDIA_TYPE.IMAGE]: 'images',
  [MEDIA_TYPE.DOCUMENT]: 'documents',
};
